import constants from '#packages/constants';

import type { AfterPlugin } from 'types/editorPlugins';

const htmlAfterPlugin: AfterPlugin = (editorAPI) => {
  editorAPI.openComponentPanel(constants.componentPanels.settings);
};

export default htmlAfterPlugin;
